import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Example from "./CarouselBox.example.mdx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const CopyToClipboardBox = makeShortcode("CopyToClipboardBox");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "carouselbox"
    }}>{`CarouselBox`}</h1>
    <p>{`Компонент `}<strong parentName="p">{`CarouselBox`}</strong>{` является оберткой над компонентом `}<strong parentName="p">{`Carousel`}</strong>{` из раздела `}<strong parentName="p">{`Компоненты`}</strong>{` и имеет идентичные свойства и методы`}</p>
    <CopyToClipboardBox text="import { CarouselBox } from '@megafon/ui-shared';" mdxType="CopyToClipboardBox" />
    <Example mdxType="Example" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      